import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'

export interface IContactAdvancedListQueryPayload {
    pagination?: PaginationType
    userType?: string
    sagaCB?: {
        onSuccess: any
    }
    query?: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const advancedListSlice = createSlice({
    name: 'hub/contacts/advanced-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IContactAdvancedListQueryPayload>) {
            state.status = STATUS.RUNNING
        },
        onChangeRow(state, action) {
            const newData = [...state.data]
            const index = newData.findIndex(item => action.payload.row._id === item._id)
            const item = newData[index]
            newData.splice(index, 1, {
                ...item,
                ...action.payload.row
            })
            state.data = newData
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            if (action.payload?.noSaveInStore !== true) {
                state.data = action.payload.data
                state.pagination = {
                    ...state.pagination,
                    skip: action.payload.skip,
                    total: action.payload.total
                }
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const advancedListActions = advancedListSlice.actions
export default advancedListSlice.reducer
